function addKey(array) {
  for (let i = 0; i < array.length; ++i) {
    array[i] = { ...array[i], key: i + 1 };
  }
  return array;
}

export default addKey;
